import React, { useCallback } from 'react'
import { trackGAEvent } from './trackGAEvent'
import { EventObject } from './schemaTypes'

export const useTrackGAEventOnce = () => {
  const [tracked, setTracked] = React.useState([] as string[])

  const trackGAEventOnce = useCallback(
    (event: EventObject) => {
      if (!tracked.includes(JSON.stringify(event))) {
        trackGAEvent(event)
        setTracked([...tracked, JSON.stringify(event)])
      }
    },
    [tracked, setTracked],
  )

  const resetGATracking = () => setTracked([])

  return { trackGAEventOnce, resetGATracking }
}
